import dynamic from 'next/dynamic';
import React from 'react';
import {useInView} from 'react-intersection-observer';
import Accordion from '../collapsible/collapsible';
import {H5, P} from '../typography/typography';
import './product-artwork-description.scss';

const VideoPlayerWithNoSSR = dynamic(
  () => import('../../atomic-design/atoms/VideoPlayer/VideoPlayer'),
  {ssr: false},
);

const AutoDetectedTagsWithNoSSR = dynamic(
  () => import('../../atomic-design/molecules/Staff/AutoDetectedTags/AutoDetectedTags'),
  {ssr: false},
);

const ProductArtworkDescription = ({
  product,
  productDescription,
  productTags,
  productAutoTags = [],
  collapsible = false,
}) => {
  const mainContent = () => {
    const {ref, inView} = useInView({
      threshold: 0.0,
    });

    return (
      <>
        <P style="p1">
          {productDescription.map((phrase, index) => {
            return (
              <React.Fragment key={index.toString()}>
                {phrase}
                <br />
              </React.Fragment>
            );
          })}
        </P>

        {product.video_link && (
          <div ref={ref} className="videoHolder">
            {inView && (
              <VideoPlayerWithNoSSR
                videoUrl={product.video_link}
                artworkName={product.name}
                artistName={product.artist_name}
              />
            )}
          </div>
        )}

        {product.materials && (
          <>
            <H5 style="art">Materials used:</H5>
            <P style="p1">{product.materials}</P>
          </>
        )}

        {productTags.length > 0 && (
          <>
            <H5 style="art">Tags:</H5>
            {productTags.map((tag, index) => {
              return (
                <React.Fragment key={index.toString()}>
                  <a href={`/art/q-${tag}/`}>
                    <span className="badge badge-light">#{tag}</span>
                  </a>
                  &nbsp;
                </React.Fragment>
              );
            })}
          </>
        )}

        {process.env.TOGGLE_PDP_AUTO_TAGS === 'enabled' && (
          <AutoDetectedTagsWithNoSSR tags={productAutoTags} productSlug={product.slug} />
        )}

        {product?.featured_collections?.length > 0 && (
          <>
            <H5 style="art">Featured by our Editors:</H5>
            <ul>
              {product.featured_collections.map((collection, index) => {
                return (
                  <React.Fragment key={index.toString()}>
                    <li>
                      <a href={collection.url} target="_blank">
                        {collection.title}
                      </a>
                    </li>
                  </React.Fragment>
                );
              })}
            </ul>
          </>
        )}
      </>
    );
  };

  const textRender = () => (
    <>
      <H5 style="art">{`${product.unique ? 'Original a' : 'A'}rtwork description:`}</H5>
      {mainContent()}
    </>
  );

  const collapsibleRender = () => (
    <Accordion label={`${product.unique ? 'Original a' : 'A'}rtwork description`} open={true}>
      {mainContent()}
    </Accordion>
  );

  return (
    <div className="artwork-description">{collapsible ? collapsibleRender() : textRender()}</div>
  );
};

export default ProductArtworkDescription;
